{
  "REGISTER": {
    "TRY_WOOT": "Crear un compte",
    "GET_STARTED": "Get started with Chatwoot",
    "TITLE": "Registre",
    "TESTIMONIAL_HEADER": "Només cal un pas per avançar",
    "TESTIMONIAL_CONTENT": "Esteu a un pas de captar els vostres clients, retenir-los i trobar-ne de nous.",
    "TERMS_ACCEPT": "En crear un compte, acceptes els nostres <a href=\"https://www.chatwoot.com/terms\">T&C</a> i <a href=\"https://www.chatwoot.com/privacy-policy\">Política de privadesa</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Registra't amb Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Nom de la companyia",
      "PLACEHOLDER": "Enter your company name. eg: Wayne Enterprises",
      "ERROR": "El nom de l'empresa és massa curt."
    },
    "FULL_NAME": {
      "LABEL": "Nom complet",
      "PLACEHOLDER": "Introdueix el teu nom complet. ex: Bruce Wayne",
      "ERROR": "El nom del compte és massa curt"
    },
    "EMAIL": {
      "LABEL": "Email de treball",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Please enter a valid work email address"
    },
    "PASSWORD": {
      "LABEL": "Contrasenya",
      "PLACEHOLDER": "Contrasenya",
      "ERROR": "La contrasenya és massa curta",
      "IS_INVALID_PASSWORD": "Password should contain atleast 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character",
      "REQUIREMENTS_LENGTH": "At least 6 characters long",
      "REQUIREMENTS_UPPERCASE": "At least one uppercase letter",
      "REQUIREMENTS_LOWERCASE": "At least one lowercase letter",
      "REQUIREMENTS_NUMBER": "At least one number",
      "REQUIREMENTS_SPECIAL": "At least one special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirma la contrasenya",
      "PLACEHOLDER": "Confirma la contrasenya",
      "ERROR": "La contrasenya no coindeix."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registration Successful",
      "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
    },
    "SUBMIT": "Crear un compte",
    "HAVE_AN_ACCOUNT": "Ja tens un compte?",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "Reenviar correu electrònic de verificació",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
